export default "__VITE_ASSET__CMf3Y9nz__"